import {makeAutoObservable} from 'mobx';

import {i18n} from '@yourcoach/i18n';

import {FlagManager} from '../../../../../../utils/store';

export class AudioPlayerThemeItem {
  constructor(
    public id: AudioPlayerThemeManager.ThemeKey,
    private manager: AudioPlayerThemeManager,
  ) {
    makeAutoObservable(this, {}, {autoBind: true});
  }

  get isSelected() {
    return this.manager.selectedId === this.id;
  }

  get name() {
    return this.manager._names[this.id];
  }

  get previewSrc() {
    return this.manager.preview[this.id];
  }

  get src() {
    return this.manager.sources[this.id];
  }

  select() {
    this.manager.setSelectedId(this.id);
  }
}

export class AudioPlayerThemeManager {
  _names: Record<AudioPlayerThemeManager.ThemeKey, string> = {
    get forest() {
      return i18n.t('shared:forest');
    },
    get rain() {
      return i18n.t('shared:rain');
    },
    get river() {
      return i18n.t('shared:river');
    },
    get starfall() {
      return i18n.t('shared:starfall');
    },
    get sunset() {
      return i18n.t('shared:sunset');
    },
  };
  activeId: AudioPlayerThemeManager.ThemeKey = 'starfall';
  isOpen = new FlagManager();
  items: AudioPlayerThemeItem[] = this.availableIds.map(
    id => new AudioPlayerThemeItem(id, this),
  );
  labels = {
    get save() {
      return i18n.t('shared:save');
    },
    get title() {
      return i18n.t('shared:theme_settings');
    },
  };
  preview: Record<AudioPlayerThemeManager.ThemeKey, string> = {
    forest: require('../assets/forest_preview.jpg'),
    rain: require('../assets/rain_preview.jpg'),
    river: require('../assets/river_preview.jpg'),
    starfall: require('../assets/starfall_preview.jpg'),
    sunset: require('../assets/sunset_preview.jpg'),
  };
  selectedId: AudioPlayerThemeManager.ThemeKey = 'starfall';
  sources: Record<AudioPlayerThemeManager.ThemeKey, string> = {
    forest: require('../assets/forest.jpg'),
    rain: require('../assets/rain.jpg'),
    river: require('../assets/river.jpg'),
    starfall: require('../assets/starfall.jpg'),
    sunset: require('../assets/sunset.jpg'),
  };

  constructor() {
    makeAutoObservable(this, {labels: false, sources: false}, {autoBind: true});
  }

  init(activeId?: AudioPlayerThemeManager.ThemeKey) {
    if (activeId) {
      this.setSelectedId(activeId);
      this.setActiveId(activeId);
    }
  }

  get activeName() {
    return this._names[this.activeId];
  }

  get activeSrc() {
    return this.sources[this.activeId];
  }

  save() {
    if (this.selectedId !== this.activeId) {
      this.activeId = this.selectedId;
    }

    this.isOpen.setFalse();
  }

  setActiveId(id: AudioPlayerThemeManager.ThemeKey) {
    this.activeId = id;
  }

  setSelectedId(id: AudioPlayerThemeManager.ThemeKey) {
    this.selectedId = id;
  }

  private get availableIds(): AudioPlayerThemeManager.ThemeKey[] {
    return ['starfall', 'rain', 'forest', 'sunset', 'river'];
  }
}

export namespace AudioPlayerThemeManager {
  export type ThemeKey = 'forest' | 'rain' | 'river' | 'starfall' | 'sunset';
}
